import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import userReducer from './slices/user';
import jobReducer from './slices/jobs/job';
import erpReducer from './slices/student/erp';
import addStudentReducer from './slices/university/addStudent';
import groupReducer from './slices/university/group';
import notificationReducer from './slices/notification'
import profileReducer from './slices/student/profile'
import dashboardReducer from './slices/dashboard';
import rhReducer from './slices/university/rh'
import uniErp from './slices/university/erp';
import authModalReducer from './slices/authModal';
import creditsReducer from './slices/credits';
import visitsReducer from './slices/visits'
import metaReducer from './slices/meta';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = { 
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  user: userReducer,
  job: jobReducer,
  erp: erpReducer,
  addStudent: addStudentReducer,
  notifications: notificationReducer,
  studentProfile: profileReducer,
  studentGroups: groupReducer,
  dashboard: dashboardReducer,
  rh: rhReducer,
  uniErp,
  product: persistReducer(productPersistConfig, productReducer),
  authModal: authModalReducer,
  credits: creditsReducer,
  visits: visitsReducer,


  meta: metaReducer,
});

export { rootPersistConfig, rootReducer };
